<template>
  <div class="jy-container">
    <div class="jy-header">
      <div class="jy-logo">
        <!--<img src="../../static/img/logo.png" alt="logo">-->
        <span>{{ project.projectName }}</span>
      </div>
      <div class="jy-navbar">
        <!--<a href="http://testyqt.easysign.cn:8081/umsp/logout">123</a>-->
        <download-customer mode="user"></download-customer>
        <span style="display: flex;align-items: center;">
          <el-button type="primary" @click="physicalSealSystem" v-if="hasPermission['sys:physical:view']">物理用印系统
          </el-button>
          <el-button type="primary" @click="toUess"
            v-if="currentUser.userType == '1' && hasPermission['sys:sealManage:view']">印章管理平台
          </el-button>
          <el-button type="primary"
            v-if="isSingOnShow && (currentUser.userType == '3' || currentUser.userType == '4') && hasPermission['sys:ssoUmsp:view']"
            @click="ssoUmsp">在线办理印章
          </el-button>
        </span>
        <div class="jy-navbar-cell" v-if="currentUser.canChgOrg !== '1'">
          <span>
            <img src="../../static/img/icon-user.png" />
            {{ null != currentUser && currentUser.userName }}
          </span>
          <div style="position: absolute; top: 63px;left: 0;z-index: 9999999;padding-top: 5px;">
            <div class="jy-userInfo">
              <div style="padding: 15px 24px;">
                <div class="jy-userInfo-tit">
                  {{ currentUser.userName }}
                  <i style="font-size: 12px;" v-if="currentUser.auditState == '1'">已认证</i>
                </div>
                <div class="jy-userInfo-p">
                  <i v-if="orgInfo != null">所属机构：{{ orgInfo.name }}</i>
                </div>
                <div class="jy-userInfo-p">上次登录时间：{{ currentUser.lastLoginTime }}</div>
              </div>
              <div class="jy-userInfo-bom">
                <div class="jy-userInfo-cell" @click="getUserInfoPage">
                  <img src="../../static/img/userinfo-icon2.png" />
                  <i>用户信息</i>
                </div>
                <div class="jy-userInfo-cell" @click="toPwd">
                  <img src="../../static/img/userinfo-icon1.png" />
                  <i>修改密码</i>
                </div>
                <!-- <div class="jy-userInfo-cell">
                  <img src="../../static/img/userinfo-icon3.png" />
                  <i>管理快捷菜单</i>
                </div>-->
              </div>
            </div>
          </div>
        </div>
        <!--<div class="jy-navbar-cell" @click="getUserInfoPage">-->
        <!--<span><img src="../../static/img/icon-set.png">用户信息</span>-->
        <!--</div>-->
        <el-dropdown v-if="currentUser.canChgOrg === '1'" trigger="click" @command="switchOrg">
          <div class="jy-navbar-cell">
            <span style="color: #FFFFFF">
              <img src="../../static/img/icon-user.png" />
              {{ null != currentUser && currentUser.userName }}
              <i v-if="currentUser.orgName && currentUser.orgList.length > 1">
                ({{ currentUser.orgName }})
              </i>
              <i style="color: #fff" class="el-icon-caret-bottom"></i>
            </span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in currentUser.orgList" :command="item" :key="index">{{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="jy-navbar-cell" @click="logout">
          <span>
            <img src="../../static/img/icon-exit.png" />安全退出
          </span>
        </div>
      </div>
    </div>
    <div class="jy-body" :class="isCollapse ? 'jy-body jy-sidebar-mini' : 'jy-body'">
      <transition>
        <div class="jy-sidebar">
          <el-menu background-color="#232e4a" text-color="#fff" active-text-color="#fff" :default-active="activeTest"
            :collapse="isCollapse">
            <!-- <el-menu-item index="1" @click="toNewPage(userMenuInfoList[0])">
              <i class="jy-icon-home" style="margin-right:10px;"></i>
              <span slot="title">首页</span>
            </el-menu-item>-->
            <template v-for="(submenu, sub) in userMenuInfoList">
              <el-submenu :index="sub.toString()" :key="sub"
                v-if="submenu.childMenuList && submenu.childMenuList.length > 0">
                <template slot="title">
                  <i :class="submenu.icon" style="margin-right:10px;"></i>
                  <span slot="title">{{ submenu.menuName }}</span>
                </template>
                <el-menu-item @click="toNewPage(menuItem)" v-for="(menuItem, index) in submenu.childMenuList"
                  :key="index" :index="(sub + '-' + index).toString()">
                  <i class="el-icon-arrow-right" style="font-size: 10px;"></i>
                  {{ menuItem.menuName }}
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :index="sub.toString()" @click="toNewPage(submenu)" :key="sub">
                <template slot="title">
                  <i :class="submenu.icon" style="margin-right:10px;"></i>
                  <span slot="title">{{ submenu.menuName }}</span>
                </template>
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </transition>
      <div class="jy-main">
        <div class="jy-location">
          <div>
            <span>{{ project.projectName }}</span>
            <span style="padding: 0 7px;">&gt;</span>
            <span style="color: #108cee;">{{ menuName }}</span>
            <!-- <el-button type="text" style="float: right;margin-right: 50px;height: inherit;"
              @click="downloadClient">下载客户端
            </el-button> -->
          </div>
        </div>
        <div class="jy-content">
          <div class="jy-board-wrapper">
            <!--操作视图窗口-->
            <router-view>
              <!--<div class="jy-board"></div>-->
            </router-view>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isShow">
      <el-dialog title="收费通知" top="50px" :visible.sync="dialogVisible" width="1300px" @close="onChargeNoticeClose">
        <div id="signContainer" style="padding:10px;clear: both">
          <iframe id="mainFrameRevocation" name="mainFrameRevocation" src="static/html/advice.html" style="width: 100%;"
            height="700px" frameborder="0"></iframe>
        </div>
      </el-dialog>
    </div>
    <!--强制修改密码-->
    <ForcePasswordChange ref='forcePasswordChangeRef'></ForcePasswordChange>
    <ClientErrorDialog ref='clientErrorDialogRef'></ClientErrorDialog>
  </div>
</template>

<script type="text/babel">
import login from "../assets/js/login";
import api from "../assets/js/api";
import global from "../assets/js/global";
import mixins from "@/mixins";
import ForcePasswordChange from "./user/admin/changePassword/forcePasswordChange";
import DownloadCustomer from "./common/DownloadCustomer.vue";
import ClientErrorDialog from "./common/ClientErrorDialog.vue";
export default {
  components: {
    ForcePasswordChange,
    DownloadCustomer,
    ClientErrorDialog
  },
  mixins: [mixins],
  data () {
    return {
      isCollapse: false,
      globalMap: api.getGlobalMap(), // 常量初始化
      currentDate: this.getNowFormatDate(),
      hasPermission: "",
      currentUser: {},
      userMenuInfoList: [],
      activeDate: new Date().getTime(),
      menuName: "",
      orgInfo: {},
      vueMsg: "myMsg", //暴露一个id
      vueRouter: "myRouter", //暴露一个路由id
      activeTest: "/",
      project: "",
      isSingOnShow: false,
      dialogVisible: false,
      isShow: false,
      srcNotice: ""
    };
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.path == "/login" || from.path == "/singlePointJump") {
        vm.isShow = true;
      }
    });
  },
  watch: {
    $route: function (to, form) {
      var that = this;
      if (to.path != "") {
        if (this.userMenuInfoList && this.userMenuInfoList.length >= 1) {
          this.userMenuInfoList.forEach((data, index) => {
            var dataObj = data.childMenuList;
            var _index = index;
            if (dataObj != null && dataObj != undefined) {
              for (var i = 0; i < dataObj.length; i++) {
                if (dataObj[i].href == to.path) {
                  //修正面包屑名称
                  this.menuName = dataObj[i].menuName;
                  //修正左侧高亮
                  this.activeTest = _index + "-" + i;
                  //console.log(dataObj[i],"对比成功,name=",dataObj[i].menuName);
                }
              }
            }
          });
        }
        // query.to == '1' //更新 用户信息
        if (to.query.to == "1") {
          this.initCurrentUser();
        }
      }
    }
  },
  methods: {
    // 打开强制修改密码
    openChangePassword () {
      const needChgPwd = String(this.currentUser.needChgPwd);
      if (needChgPwd === "1") {
        this.$refs.forcePasswordChangeRef.openChangePassword();
      }
    },
    //切换内部机构
    switchOrg (data) {
      console.log(data);
      let _this = this;
      let params = {
        orgId: data.id,
        userId: this.currentUser.userId
      };
      window._axiosPromiseArr.forEach((ele, index) => {
        ele.cancel();
        delete window._axiosPromiseArr[index];
      });
      this.$xLoading.show();
      api.user.changeOrgLogin(params).then(res => {
        window._axiosPromiseArr = [];
        if (res.data.code === "0") {
          sessionStorage.setItem("token", res.data.data);
          this.initCurrentUser();
          // this.getSelectMenuList();
          setTimeout(function () {
            _this.$router.push({ path: "/blank", query: { path: "/index" } });
          }, 1000);
        } else {
          this.$message.error(res.data.message);
        }
        setTimeout(function () {
          _this.$xLoading.close();
        }, 3000);
      });
    },
    openWindow: (url, targetType = "_blank", id = "open") => {
      // 如果存在则删除
      if (document.getElementById(id)) {
        document.body.removeChild(document.getElementById(id));
      }
      const a = document.createElement("a");
      a.setAttribute("href", url);
      // a.setAttribute('download', url)
      a.setAttribute("target", targetType);
      a.setAttribute("id", id);
      document.body.appendChild(a);
      a.click();
    },
    downloadClient () {
      api.menu.downloadClient().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.message);
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    // 物理用印系统
    physicalSealSystem () {
      api.menu.physicalSealSystem().then(res => {
        if (res.data.code == 0) {
          // window.open(res.data.message, "_blank");
          this.openWindow(res.data.message);
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    ssoUmsp () {
      api.menu.ssoUmsp().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.message, "_blank");
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    // 收费通知关闭后，通知首页显示签章指引（仅外部用户）
    onChargeNoticeClose () {
      if (this.currentUser.userType == '3' || this.currentUser.userType == '4') {
        this.$EventBus.$emit('chargeNoticeClosed')
      }
    },
    toUess () {
      api.menu.toUess().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.data, "_blank");
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
            center: true
          });
        }
      });
    },
    singleSignOn: function () {
      api.menu.singleSignOn().then(res => {
        if (res.data.code == 0) {
          window.open(res.data.message, "_blank");
          var url = res.data.message;
          var url1 = url.split("?");
          var index = url1[0].lastIndexOf("/");
          var str = url1[0].substring(0, index + 1);
          var UMSPurl = str + "/logout";
          login.logout1(UMSPurl);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    toPwd: function () {
      this.$router.push("/user/chgPwd");
    },
    shousuo: function () {
      this.isCollapse ? (this.isCollapse = false) : (this.isCollapse = true);
    },
    toNewPage: function (item) {
      console.log(item, "点击首页");
      //this.$router.push({ path: "/blank", query: { path: item.href } });
      //this.menuName = item.menuName;
      //console.log(item.menuName)
      //console.log(item.href)
      if (this.currentUser.auditState != "1" && item.menuName == "新建合同") {
        this.$message.warning("您还未实名");
        return false;
      } else {
        this.$router.push({
          path: "/blank",
          query: { path: item.href }
        });
        this.menuName = item.menuName;
      }

      /*if(this.currentUser.auditState == '1'){
        this.$router.push({path: '/blank', query: {path: item.href}});
        this.menuName = item.menuName;
      }else{
        //console.log("未认证");
        this.$message.warning("未实名")
      }*/
    },

    menuTreeByUserAndLevel: function () {
      var _this = this;
      api.menu.menuTreeByUserAndLevel().then(res => {
        if (res.data.code === "0") {
          _this.userMenuInfoList = res.data.data[0].childMenuList;
          // console.log(_this.userMenuInfoList, "菜单数据 oo");
        }
      });
    },

    initCurrentUser: function () {
      var _this = this;
      api.user.currentUserInfo().then(res => {
        if (null != res.data && res.data.ok) {
          _this.currentUser = res.data.data;
          //  //console.log(_this.currentUser);

          _this.dialogVisible = true;
          // _this.srcNotice = api.base + "/static/H5PDF/web/viewer.html?file=" + $.base64.encode(api.basePath + `/contract/common/downloadAdviceOfCharge?access_token=${api.token()}&timeStamp=${new Date().getTime()}`);
          console.log("api.baseapi.baseapi.base", api.base);
          _this.srcNotice = "/static/html/advice.html";
          sessionStorage.setItem(
            "currentUser",
            JSON.stringify(_this.currentUser)
          );
          _this.menuTreeByUserAndLevel();
          api.org.selectOrgInfo(_this.currentUser.orgId).then(res => {
            if (res.data != null && res.data.ok) {
              _this.orgInfo = res.data.data;
            }
          });
          this.openChangePassword();
        }
      });
    },
    initPermissionMap: function () {
      var _this = this;
      // 保存用户权限列表
      api.menu.menuTreeByUserAndLevel(true).then(res => {
        if (res.data != null && res.data.ok) {
          var permissions = res.data.data;

          var permissionMap = {};
          for (var i = 0; i < permissions.length; i++) {
            permissionMap[permissions[i].permission] = true;
          }
          // console.log(permissionMap['sys:user:add']);

          _this.permissionMap = permissionMap;
          sessionStorage.setItem(
            "permissionMap",
            JSON.stringify(_this.permissionMap)
          );
          this.hasPermission = permissionMap;
        }
      });
    },
    initGlobalMap: function () {
      var _this = this;
      // 保存全局常用常量类供前端使用
      _this.dict.getGlobalMap().then(res => {
        if (res.data != null && res.data.ok) {
          _this.globalMap = res.data.data;
          sessionStorage.setItem("globalMap", JSON.stringify(_this.globalMap));
        }
      });
    },
    getUserInfoPage: function () {
      var _this = this;
      _this.globalMap = api.getGlobalMap();

      if (null == _this.globalMap) {
        _this.logout();
        return;
      }

      if (
        _this.globalMap["UserType.OUTER_CORP"] === _this.currentUser.userType
      ) {
        // 外部企业用户
        _this.$router.push("/user/detail");
      } else {
        _this.$router.push("/user/detail");
      }
    },

    logout: function () {
      let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
      // if (currentUser.userType == 3 || currentUser.userType == 4) {
      //     login.logout().then(res => {
      //         if (res.data.code == 0) {
      //             sessionStorage.clear();
      //             this.$router.push("/login");
      //         }
      //     });
      //     return;
      // }

      // login.logout().then(res => {
      //     if (res.data.code == 0) {
      //         login.logoutNewFtpPath().then(res1 => {
      //             if (res1.data.code == 0) {
      //                 login.logout1(res1.data.data);
      //                 login.crcc16LogOutUrl().then(result => {
      //                     if (result.data.code == 0) {
      //                         sessionStorage.clear();
      //                         window.location.href = result.data.data;
      //                     }
      //                 });
      //             }
      //         });
      //     }
      // });

      if (currentUser.currentServiceId != 2) {
        login.logout().then(res => {
          if (res.data.code == 0) {
            sessionStorage.clear();
            this.$router.push("/login");
          }
        });
        return;
      }

      login.logout().then(res => {
        if (res.data.code == 0) {
          login.crcc16LogOutUrl().then(result => {
            if (result.data.code == 0) {
              sessionStorage.clear();
              window.location.href = result.data.data;
            }
          });
        }
      });
    },

    getCurrentDate: function () {
      var _this = this;
      _this.currentDate = _this.getNowFormatDate();
    },
    parentMsg (msg, state) {
      // console.log(state);
      if (state == "s") {
        this.$message.success(msg);
      } else if (state == "w") {
        this.$message.warning(msg);
      } else if (state == "e") {
        this.$message.error(msg);
      }
    },
    parentRouter (route) {
      // console.log(route,"刷新页面");
      this.$router.push({ path: "/blank", query: { path: route } });
    },
    //是否显示“在线办理电子印章”按钮
    getOneSysParameter () {
      api.menu.getOneSysParameter("onLineTransSeal").then(res => {
        // console.log(res, "是否显示在线办理电子印章");
        if (res.data.data.value === "1") {
          this.isSingOnShow = true;
        }
      });
    }
  },
  created () {
    this.initCurrentUser();
    this.initPermissionMap();
    this.initGlobalMap();
    // this.initCurrentUserInfo();
    api.menu.getProjectName().then(res => {
      // console.log(res,"????");
      this.project = res.data.data;
    });
    this.$nextTick(function () {
      setInterval(this.getCurrentDate, 1000);
    });
    var self = this;
    window[this.vueMsg] = (msg, state) => {
      //将这个函数给app.js调用 vue中的message
      self.parentMsg(msg, state);
    };
    window[this.vueRouter] = route => {
      //将这个函数给app.js调用 vue中的跳转功能
      self.parentRouter(route);
    };
    this.getOneSysParameter();
  },
  mounted () {
    this.$xLoading.close();
    this.getPorjectConfig();
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/index.vue